import type { Client } from '@data/clients';
import { Wrapper, Track, LogoItem, LogoImg, SectionLabel } from './styles';

interface LogoCarouselProps {
  clients: Client[];
  label?: string;
  /** Velocidade em segundos — menor = mais rápido */
  speed?: number;
}

export function LogoCarousel({
  clients,
  label = 'Clientes que confiam no nosso trabalho',
  speed = 30,
}: LogoCarouselProps) {
  // Duplica o array para criar o efeito infinito contínuo
  const doubled = [...clients, ...clients, ...clients, ...clients, ...clients];

  return (
    <div>
      {label && <SectionLabel>{label}</SectionLabel>}
      <Wrapper>
        <Track className="logo-carousel-track" style={{ animationDuration: `${speed}s` }}>
          {doubled.map((client, i) => (
            <LogoItem key={`${client.id}-${i}`}>
              <LogoImg src={client.logo} alt={client.name} title={client.name} />
            </LogoItem>
          ))}
        </Track>
      </Wrapper>
    </div>
  );
}
